var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrubtech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1442,
    height: 1080,
    viewBox: "0 0 1442 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1442,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1442,
    height: 1080,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M303.563,913.836l-.469.469a65.638,65.638,0,0,1-92.812,0,65.625,65.625,0,0,1,46.406-112.032A65.618,65.618,0,0,1,322.313,867.9v65.625q0,20.506-14.766,35.625-20.627,20.623-49.8,20.625t-49.688-20.625a69.861,69.861,0,0,1-12.422-16.289,8.665,8.665,0,0,1-1.406-4.921,9.4,9.4,0,0,1,9.375-9.375,9.321,9.321,0,0,1,6.68,2.7,14.118,14.118,0,0,1,1.992,2.812,53.441,53.441,0,0,0,9.023,11.836,51.492,51.492,0,0,0,72.891,0q9.374-11.25,9.375-22.383Zm-46.875-92.813a46.812,46.812,0,1,0,33.164,13.711A45.178,45.178,0,0,0,256.688,821.023Z",
    fill: "#51b4ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M342.063,811.648a9.375,9.375,0,0,1,18.75,0v10.313q19.688-19.687,46.875-19.688a66.074,66.074,0,0,1,25.2,4.688,12.025,12.025,0,0,1,3.867,2.461,9.325,9.325,0,0,1,2.7,6.68,9.387,9.387,0,0,1-13.477,8.437,46.5,46.5,0,0,0-18.281-3.516A46.812,46.812,0,0,0,360.813,867.9v56.25a9.375,9.375,0,0,1-18.75,0Z",
    fill: "#51b4ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M581.438,924.148a9.375,9.375,0,0,1-18.75,0v-7.617a60.947,60.947,0,0,1-103.125-43.945V811.648a9.375,9.375,0,0,1,18.75,0v60.938a42.188,42.188,0,0,0,84.375,0V811.648a9.375,9.375,0,0,1,18.75,0Z",
    fill: "#51b4ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M619.938,821.961l.469-.469A65.636,65.636,0,1,1,601.188,867.9V755.164a9.375,9.375,0,0,1,18.75,0Zm46.875,92.812a46.811,46.811,0,1,0-33.164-13.71A45.18,45.18,0,0,0,666.813,914.773Z",
    fill: "#51b4ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M817.813,914.773a9.375,9.375,0,0,1,0,18.75q-46.876,0-46.875-46.875V821.023h-9.375a9.375,9.375,0,0,1,0-18.75h9.375V755.4a9.375,9.375,0,0,1,18.75,0v46.875h18.867a9.375,9.375,0,0,1,0,18.75H789.688v65.625Q789.688,914.773,817.813,914.773Z",
    fill: "#9ed739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M948.657,901.648a9.4,9.4,0,0,1,9.375,9.375,9.329,9.329,0,0,1-2.7,6.68q-18.165,15.82-42.773,15.82A65.628,65.628,0,1,1,978.188,867.9a9.4,9.4,0,0,1-9.375,9.375h-102.3a47.1,47.1,0,0,0,46.055,37.5q17.578,0,30.234-11.132A9.328,9.328,0,0,1,948.657,901.648Zm9.961-43.125a47.039,47.039,0,0,0-92.11,0Z",
    fill: "#9ed739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1099.891,901.414a9.4,9.4,0,0,1,9.375,9.375,9.716,9.716,0,0,1-2.93,6.914q-18.165,15.82-42.773,15.82a65.625,65.625,0,1,1,0-131.25q24.609,0,42.773,15.821a9.353,9.353,0,0,1,3.282,7.265,9.4,9.4,0,0,1-9.375,9.375,9.159,9.159,0,0,1-5.977-2.109,46.867,46.867,0,1,0-.117,70.664A9.211,9.211,0,0,1,1099.891,901.414Z",
    fill: "#9ed739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1129.188,755.4a9.375,9.375,0,0,1,18.75,0v63.868a60.947,60.947,0,0,1,103.125,43.945v60.937a9.375,9.375,0,0,1-18.75,0V863.211a42.188,42.188,0,0,0-84.375,0v60.937a9.375,9.375,0,0,1-18.75,0Z",
    fill: "#9ed739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M983,265.69l-22.14,44.28a106.8,106.8,0,0,1,17.612,58.787A107.944,107.944,0,0,1,948.5,443.19a104.717,104.717,0,0,1-50.084,29.182,389.1,389.1,0,0,1-69.666,9.916c-54.512,2.627-104.607,3.6-159.26,2.551-18.786-.366-37.572-1.183-56.3-2.754-17.867-1.5-35.622-4.043-53.372-6.524-16.284-2.277-31.219-6.727-45.3-15.46a107.421,107.421,0,0,1,43.318-197.935,99.816,99.816,0,0,1,13.251-.851,107.175,107.175,0,0,1,32.993,5.193,102.2,102.2,0,0,1-1.656-18.623,105.712,105.712,0,0,1,3.537-27.308A107.618,107.618,0,0,1,655.01,155.6c8.985-23.158,23.666-47.025,32.927-61.013A163.623,163.623,0,0,0,562.049,216.816,152.222,152.222,0,0,0,531.267,515.7c15.6,4.21,31.947,5.395,47.976,6.954q17.822,1.734,35.681,3.047,47.091,3.479,94.34,4.1c36.9.429,73.855-.562,110.634-3.708q20.019-1.711,39.944-4.359v55.194a30.976,30.976,0,0,1-31.337,31.337c-116.4,13.431-214.884,0-214.884,0a31.372,31.372,0,0,1-31.337-31.337v-5.2H537.516v5.2a76.19,76.19,0,0,0,76.1,76.1s94.012,13.43,214.884,0c44.767-4.477,76.1-34.14,76.1-76.1V517.207A152.169,152.169,0,0,0,983,265.69Z",
    fill: "#51b4ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M790.408,107.181a150.806,150.806,0,0,0-45.4-10.968l-53.989,93.519a40.274,40.274,0,1,0,41.231,40.246,40.7,40.7,0,0,0-3.4-16.206ZM691.964,245.647a15.669,15.669,0,1,1,15.669-15.669A15.687,15.687,0,0,1,691.964,245.647Z",
    fill: "#9ed739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M862.8,169.542a153.8,153.8,0,0,0-30.621-36.486L708.931,346.418A40.274,40.274,0,1,0,748.1,399.244a39.185,39.185,0,0,0,2.06-12.58,40.7,40.7,0,0,0-3.4-16.2ZM709.871,402.333a15.533,15.533,0,0,1-12.49-6.268,15.359,15.359,0,0,1-3.179-9.4,15.669,15.669,0,1,1,24.623,12.8A15.149,15.149,0,0,1,709.871,402.333Z",
    fill: "#9ed739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M941.767,233.962a128.927,128.927,0,0,0-12.58-5.909,146.25,146.25,0,0,0-30.531-8.953l-55.423,95.981a40.274,40.274,0,1,0,41.231,40.246,40.7,40.7,0,0,0-3.4-16.206ZM844.174,371a15.669,15.669,0,1,1,15.668-15.669A15.686,15.686,0,0,1,844.174,371Z",
    fill: "#9ed739"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrubtech);
export default __webpack_public_path__ + "static/media/grubtech.4490d7d5b9e6eae291687126190c936e.svg";
export { ForwardRef as ReactComponent };